// assets
import { CalendarOutlined, ShopOutlined, ShoppingOutlined, BarChartOutlined } from '@ant-design/icons';
import { reactLocalStorage } from 'reactjs-localstorage';

// icons
const icons = {
  CalendarOutlined,
  ShopOutlined,
  ShoppingOutlined,
  BarChartOutlined
};

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

let getUserInfo = reactLocalStorage.get('user_info')
getUserInfo = getUserInfo ? JSON.parse(getUserInfo) : null

const pagesJastip = {
  id: 'pages-jastip',
  title: 'Jastip',
  type: 'group',
  children: [
    {
      id: 'jastip',
      title: 'Jastip',
      type: 'item',
      url: '/jastip',
      icon: icons.ShoppingOutlined,
      breadcrumbs: true
      // target: true
    }
  ]
};

export default pagesJastip;
